module.exports = __webpack_public_path__ + "static/img/200108.b20cc0ae.png";